<template>
    <div class="container has-text-centered">
        <!--
        <font-awesome-icon icon="address-card" class="fa" />
        <h3 class="statement">address</h3>
        <br>
-->
        <h4>Logan's Barber Shop</h4>
        <p>38 Rugby Rd, Cubbington</p>
        <p>Leamington Spa CV32 7JE</p>
        <p>Tel: 01926 883115</p>
        <br>
    </div>
</template>
<script>
    export default {
        name: 'post-code'
    }

</script>
<style scoped>
    .fa {

        font-size: 5rem;

    }

    h4 {
        font-weight: 400;
    }

</style>
